import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const objectiveImporterSelectors = importerSelectors(
  'objective.importer',
);

export default objectiveImporterSelectors;
